import 'view/css/e-invoice.css';

import { useEffect, useState } from 'react';

import API from 'service/api';

import PopMessage from 'component/pop-msg/PopMessage';

import EInvoiceSelectionFilter from './EInvoiceSelectionFilter';
import EInvoiceSelection from './EInvoiceSelection';

const flattenBills = (bills) =>
{
  let arr = [];
  if (bills) for (let company of Object.keys(bills))
  {
    let l2_items = bills[company];
    for (let license of l2_items.keys())
    {
      let l3_item = l2_items.get(license);
      if (l3_item.is_email
        ||l3_item.is_whatsapp)
      { arr.push(l3_item); }
    }
  }
  return arr;
}

const EInvoiceModal = ({bills, addOns}) =>
{
  const [disabled, setDisabled] = useState(false);
  const [items, setItems] = useState([]);

  const [filter, setFilter] = useState({
    company: '', district: '', location: '',
    cd_license: '', srv_plan: '',
    invoice_type: '', media_type: '',
  })

  const getDtoMapper = flag => {
    return x => {
      const {
        company, uid, cd_license, due_lv,
        srv_plan, loc_key, loc_psn, yrmo,
        total, susp_mo, today, signal,
      } = x;
  
      const dto = {
        company, uid, cd_license, due_lv,
        srv_plan, loc_key, loc_psn, yrmo,
        total, susp_mo, today, signal,
      };
  
      if (flag)
      {
        dto[flag] = true;
      } else {
        dto.is_whatsapp = x.is_whatsapp && (!filter.media_type || filter.media_type == 'whatsapp');
        dto.is_email    = x.is_email    && (!filter.media_type || filter.media_type == 'email'   );
      }

      return dto;
    };
  }
 

  useEffect(() => {
    setItems(flattenBills(bills));
  }, [bills]);


  const sendAllSelected = () => {
    const selectedItems = items
      .filter(i => i.selected);

    if (selectedItems.length <= 0) {
      PopMessage.show('請先選擇要寄出的賬單。', '訊息', 'danger');
      return false;
    }

    onSend(selectedItems).then(() => {
      selectedItems.forEach(x => x.selected = false);
      setItems([...items]);
    }).then(() => {
      setTimeout(() => setDisabled(false), 10000); // 10s
    });
    
  }

  const onSend = (selectedItems, flag) =>
  {
    const items = selectedItems.map(getDtoMapper(flag));
    const dto = { addOns, items };

    const promise = new Promise((resolve, reject) =>
    {
      setTimeout(() => {
        API.sendInvoice(dto).then(resp => {
          if (resp.success) {
            PopMessage.show('已排程寄單工作。', '成功', 'success');
          } else {
            PopMessage.show('寄發電子賬單時出現錯誤。', '錯誤', 'danger');
          }
        });
        resolve();
      });
    });

    return promise;
  }

  return (<div className="e-invoice-modal">
    <EInvoiceSelectionFilter onChange={setFilter} />
    <EInvoiceSelection items={items} filter={filter} onSend={onSend} />
    <div className="btn-group">
      <button className="btn btn-small red" disabled={disabled}
        onClick={sendAllSelected}>發送已選取</button>
    </div>
  </div>);
}

export default EInvoiceModal;